import { useState } from "react";

/**
 * Hidden model picker — opened by 10-tapping the sidebar logo.
 *
 * Persists to `localStorage.modelOverride`; the value is injected as
 * `X-Model-Override` on every API call (see `shared/api/http-client.ts`
 * and `use-agent-stream.ts`). Backend whitelists accepted values, so
 * anything outside this list is silently ignored upstream.
 *
 * Default-selected option is `Giga-Cowork-L` to match the backend's env
 * default — a fresh user with no localStorage entry already gets the
 * large Qwen.
 */
interface Props {
  onClose: () => void;
}

const OPTIONS: { id: string; label: string; hint: string }[] = [
  {
    id: "Giga-Cowork-L",
    label: "Giga-Cowork-L",
    hint: "Большая модель — медленнее, умнее. По умолчанию.",
  },
  {
    id: "Giga-Cowork",
    label: "Giga-Cowork",
    hint: "Малая модель — быстрее, дешевле.",
  },
  {
    id: "Giga-Cowork-Evo",
    label: "Giga-Cowork-Evo",
    hint: "То же, что L, но в контуре Evo (api.giga.chat).",
  },
];

export function ModelOverrideDialog({ onClose }: Props) {
  const [picked, setPicked] = useState<string>(
    localStorage.getItem("modelOverride") || "Giga-Cowork-L",
  );

  const save = () => {
    localStorage.setItem("modelOverride", picked);
    onClose();
  };

  return (
    <div className="copy-dialog-backdrop" onClick={onClose}>
      <div className="copy-dialog" onClick={(e) => e.stopPropagation()}>
        <header className="copy-dialog-head">
          <h2 className="copy-dialog-title">Модель</h2>
          <button
            className="copy-dialog-close"
            onClick={onClose}
            aria-label="Закрыть"
          >
            ×
          </button>
        </header>

        <p className="copy-dialog-hint">
          Применяется ко всем чатам в этом браузере. Действует со следующего сообщения.
        </p>

        <ul className="copy-dialog-list">
          {OPTIONS.map((opt) => (
            <li key={opt.id}>
              <button
                type="button"
                className={`copy-dialog-item${picked === opt.id ? " copy-dialog-item--checked" : ""}`}
                onClick={() => setPicked(opt.id)}
              >
                <span
                  className={`copy-dialog-radio${picked === opt.id ? " copy-dialog-radio--on" : ""}`}
                />
                <span className="copy-dialog-item-text">
                  <span className="copy-dialog-item-label">{opt.label}</span>
                  <span className="copy-dialog-item-hint">{opt.hint}</span>
                </span>
              </button>
            </li>
          ))}
        </ul>

        <footer className="copy-dialog-foot">
          <button
            type="button"
            className="copy-dialog-btn copy-dialog-btn--ghost"
            onClick={onClose}
          >
            Отмена
          </button>
          <button
            type="button"
            className="copy-dialog-btn copy-dialog-btn--primary"
            onClick={save}
          >
            Сохранить
          </button>
        </footer>
      </div>
    </div>
  );
}
